/**
 * Service Routes - API Tracking
 * GET/POST /api/v1/routes/ , GET/PUT/PATCH/DELETE /api/v1/routes/{id}/
 */
import { createTrackingClient } from "../trackingApi";

export interface TrackingRoute {
  id: string;
  name: string;
  driver_id: number | null;
  school_id: number | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface RouteUpsertPayload {
  name: string;
  driver_id?: number | null;
  school_id?: number | null;
  is_active?: boolean;
}

function getClient(accessToken: string | undefined) {
  return createTrackingClient(accessToken);
}

export async function fetchTrackingRoutes(
  accessToken: string | undefined
): Promise<TrackingRoute[]> {
  const client = getClient(accessToken);
  const { data } = await client.get<TrackingRoute[] | { results: TrackingRoute[] }>("/api/v1/routes/");
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object" && "results" in data) return (data as { results: TrackingRoute[] }).results;
  return [];
}

export async function createTrackingRoute(
  accessToken: string | undefined,
  payload: RouteUpsertPayload
): Promise<TrackingRoute> {
  const client = getClient(accessToken);
  const { data } = await client.post<TrackingRoute>("/api/v1/routes/", payload);
  return data;
}

export async function updateTrackingRoute(
  accessToken: string | undefined,
  id: string,
  payload: RouteUpsertPayload
): Promise<TrackingRoute> {
  const client = getClient(accessToken);
  const { data } = await client.put<TrackingRoute>(`/api/v1/routes/${id}/`, payload);
  return data;
}

export async function deleteTrackingRoute(
  accessToken: string | undefined,
  id: string
): Promise<void> {
  const client = getClient(accessToken);
  await client.delete(`/api/v1/routes/${id}/`);
}
